export default __webpack_public_path__ + "static/media/EM0320.34I-22002_-25389_0.d3446800.jpg";